import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FontManager } from "@/features/admin/components/font-manager";
import { PageContainer } from "@fleet/ui";

function AdminFontsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <FontManager />
    </PageContainer>
  );
}

export interface AdminFontsSearch {
  /** Active tab (`?tab=available|approved`). */
  tab?: "available" | "approved";
  /** Deep-link: font search query. */
  q?: string;
  /** Category filter (registry browser). */
  category?: string;
  /** Single-font preview deep-link. */
  font?: string;
}

export const adminFontsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/fonts",
  validateSearch: (search: Record<string, unknown>): AdminFontsSearch => ({
    tab:
      search.tab === "approved" ? "approved" : search.tab === "available" ? "available" : undefined,
    q: typeof search.q === "string" && search.q.trim() !== "" ? search.q : undefined,
    category:
      typeof search.category === "string" && search.category !== "all"
        ? search.category
        : undefined,
    font: typeof search.font === "string" && search.font.trim() !== "" ? search.font : undefined,
  }),
  component: AdminFontsPage,
});
